export default __webpack_public_path__ + "static/media/Lip_6_M.63de464d.svg";